import {svgIconWrapper} from '../svg-icon-wrapper';

import FolderRegular from './folder-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <FolderRegular {...validProps} />;
}

SvgComponent.iconName = 'folder-regular';

export const FolderRegularIcon = svgIconWrapper(SvgComponent);
